import FieldNames from '../defaults/FieldNames.json'

export function configureFiscalYearOverrides(featureAttributeArray, config) {
    const outConfig = {
        fuels: {
            objectId: null,
            fiscalYearOverridesActive: false,
            fiscalYearOverridesDate: null,
            defaultFiscalYearDate: new Date(Date.UTC(new Date().getUTCFullYear(), 9, 15))
        },
        postFire: {
            objectId: null,
            fiscalYearOverridesActive: false,
            fiscalYearOverridesDate: null,
            defaultFiscalYearDate: new Date(Date.UTC(new Date().getUTCFullYear(), 9, 15))
        }
    }
    featureAttributeArray.forEach(attr => {
        const entityType = attr[FieldNames.overrideFields.entityType]
        if (entityType === config.ifprsOverrides.entityTypes.fuels) {
            outConfig.fuels.fiscalYearOverridesActive = attr[FieldNames.overrideFields.enabled] === 1
            outConfig.fuels.fiscalYearOverridesDate = attr[FieldNames.overrideFields.value]
            outConfig.fuels.objectId = attr[FieldNames.overrideFields.objectID]
        } else if (entityType === config.ifprsOverrides.entityTypes.postFire) {
            outConfig.postFire.fiscalYearOverridesActive = attr[FieldNames.overrideFields.enabled] === 1
            outConfig.postFire.fiscalYearOverridesDate = attr[FieldNames.overrideFields.value]
            outConfig.postFire.objectId = attr[FieldNames.overrideFields.objectID]
        }
    });
    return outConfig
}